module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/hannah-bennett/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-hannah-bennett.json
// module id = 1594
// module chunks = 165497393597108